/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { RejectReasonResponse } from './';
import {
    RejectReasonResponseFromJSON,
    RejectReasonResponseFromJSONTyped,
    RejectReasonResponseToJSON,
} from './';
import type { StatusResponse } from './';
import {
    StatusResponseFromJSON,
    StatusResponseFromJSONTyped,
    StatusResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateReferralSubmissionStatusRequest
 */
export interface UpdateReferralSubmissionStatusRequest {
    /**
     * 
     * @type {StatusResponse}
     * @memberof UpdateReferralSubmissionStatusRequest
     */
    status: StatusResponse;
    /**
     * 
     * @type {RejectReasonResponse}
     * @memberof UpdateReferralSubmissionStatusRequest
     */
    rejectReason?: RejectReasonResponse;
}

/**
 * Check if a given object implements the UpdateReferralSubmissionStatusRequest interface.
 */
export function instanceOfUpdateReferralSubmissionStatusRequest(value: object): value is UpdateReferralSubmissionStatusRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdateReferralSubmissionStatusRequestFromJSON(json: any): UpdateReferralSubmissionStatusRequest {
    return UpdateReferralSubmissionStatusRequestFromJSONTyped(json, false);
}

export function UpdateReferralSubmissionStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReferralSubmissionStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': StatusResponseFromJSON(json['status']),
        'rejectReason': json['rejectReason'] == null ? undefined : RejectReasonResponseFromJSON(json['rejectReason']),
    };
}

export function UpdateReferralSubmissionStatusRequestToJSON(value?: UpdateReferralSubmissionStatusRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': StatusResponseToJSON(value['status']),
        'rejectReason': RejectReasonResponseToJSON(value['rejectReason']),
    };
}

